import {Button} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'

const GlobalButton = ({...props}) => (
  <Button
    color={CommonColors.white}
    bg={CommonColors.primary}
    w={'fit-content'}
    _hover={{
      bg: CommonColors.primaryHover,
    }}
    _active={{
      opacity: 0.5,
    }}
    {...props}>
    {props?.children}
  </Button>
)

export default GlobalButton
